export default {
  iconSmall: {
    fontSize: 20,
    color: '#000'
  },
  iconCenter: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 8px'
  },
  back: {
    borderRadius: 30,
    padding: 12
  },
  slider: {
    color: '#000'
  },
  track: {
    height: 3
  },
  thumb: {
    height: 0,
    '&:focus, &:hover, .Mui-active': {
      height: 12,
      width: 12,
      boxShadow: 'inherit',
    },
  },
  volumeThumb: {
    width: 12,
    height: 12,
  },
  blurry: {
    filter: 'blur(0.2rem)',
    userSelect: 'none',
  }
}
